module.exports = __webpack_public_path__ + "static/media/heroes-three.710700c3.png";